import axios from "axios";
import constants from "./constants";

export const getBussinessListFormData = (token) => { //Bussiness page get  
  return axios.get(`${constants.API_BASE_URL}business`
  , {
    headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
  });
};
export const getUserBussinessListFormData = (token) => { //Bussiness page get  
  return axios.get(`${constants.API_BASE_URL}business/user`
  , {
    headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
  });
};


export const getCategoryListFormData = () => { //Category Listing page get  
  return axios.get(`${constants.API_BASE_URL}category`
  , {
    headers: { "Content-Type": "application/json" },
  });
};

export const getblogListFormData = (token) => { //blog/all-blog Listing page get  
  return axios.get(`${constants.API_BASE_URL}blog/all-blog`
  , {
    headers: { "Content-Type": "application/json" , "Authorization": `Bearer ${token}`},
  });
};
export const getblogDetailListFormData = (token,id) => { //blog/all-blog Listing page get  
  return axios.get(`${constants.API_BASE_URL}blog/get-blog/${id}`
  , {
    headers: { "Content-Type": "application/json" , "Authorization": `Bearer ${token}`},
  });
};

export const getblogListUserFormData = (token) => { //blog/all-blog Listing page get  
  return axios.get(`${constants.API_BASE_URL}blog/all-blog/user`
  , {
    headers: { "Content-Type": "application/json" , "Authorization": `Bearer ${token}`},
  });
};
export const createBusinessData = async (businessData,token) => {
  
  return axios.post(`${constants.API_BASE_URL}business/create/business`, businessData, {
    headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${token}`
    }
  });
  
};
export const createRegistrationData = async (businessData,token) => {
  
  return axios.post(`${constants.API_BASE_URL}payment/initiate`, businessData, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
        
        'Authorization': `Bearer ${token}`
    }
  });
  
};
export const updateBusinessData = async (businessData,token,bid) => {
  
  return axios.post(`${constants.API_BASE_URL}business/edit/${bid}/business`, businessData, {
    headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${token}`
    }
  });
  
};
export const createBlogData = async (blogData,token) => {
  
  try {
    const response = await axios.post(`${constants.API_BASE_URL}blog/create-blog/blog`, blogData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            "Authorization": `Bearer ${token}`
        },
    });
    return response.data;
} catch (error) {
    console.error("Error creating business", error);
    throw error;
 
  }
};

export const loginDetails = async (email,pass) => {
  

  try {
      const response = await axios.post(`${constants.API_BASE_URL}auth/login`, {email,pass});
      return response.data;
  } catch (error) {
      console.error("Error creating business", error);
      throw error;
  }
};
export const login = async (formData) => {
  try {
      const response = await axios.post(`${constants.API_BASE_URL}auth/login`, formData);
      return response.data;
  } catch (error) {
      console.error("Error creating business", error);
      throw error;
  }
};
export const getCountryListFormData = () => { //Bussiness page get  Country 
  return axios.get(`${constants.API_BASE_URL}country`
  , {
    headers: { "Content-Type": "application/json" },
  });
};
export const getCountryStateListFormData = (countryCode) => { //Bussiness page get  Country base state
  return axios.get(`${constants.API_BASE_URL}location/states/${countryCode}`
  , {
    headers: { "Content-Type": "application/json" },
  }); 
};

export const getStateListByCountryId = (countryId) => { //Bussiness page get  Country base state
  return axios.get(`${constants.API_BASE_URL}location/statesbyid/${countryId}`
  , {
    headers: { "Content-Type": "application/json" },
  }); 
};
export const getCityListByStateId = (stateId) => { //Bussiness page get  State base city
  return axios.get(`${constants.API_BASE_URL}location/citiesbyid/${stateId}`
  , {
    headers: { "Content-Type": "application/json" },
  });
};
export const getCountryCityListFormData = (stateCode) => { //Bussiness page get  State base city
  return axios.get(`${constants.API_BASE_URL}location/cities/${stateCode}`
  , {
    headers: { "Content-Type": "application/json" },
  });
};
export const getCountrydirectCityListFormData = (countryCode) => { //Contact us page get  city by country code
  return axios.get(`${constants.API_BASE_URL}location/citiesbycountry/${countryCode}`
  , {
    headers: { "Content-Type": "application/json" },
  });
};
export const getEventsListFormData = () => { //Events
  return axios.get(`${constants.API_BASE_URL}event`, {
    headers: { "Content-Type": "application/json"},
  });
};
export const getEventsDetailFormData = (data) => { //Events
  return axios.get(`${constants.API_BASE_URL}event/${data}`, {
    headers: { "Content-Type": "application/json"},
  });
};
export const getUserEventsListFormData = (token) => { //Events
  return axios.get(`${constants.API_BASE_URL}event/user`, {
    headers: { "Content-Type": "application/json",
       "Authorization": `Bearer ${token}`
     },
  });
};
export const getNewsListFormData = () => { //News
  return axios.get(`${constants.API_BASE_URL}news`
  , {
    headers: { "Content-Type": "application/json"},
  });
};
export const getNewsDetailFormData = (data) => { //News
  return axios.get(`${constants.API_BASE_URL}news/${data}`
  , {
    headers: { "Content-Type": "application/json"},
  });
};
export const getUserJobsListFormData = (token) => { //Jobs
  return axios.get(`${constants.API_BASE_URL}job/user`
  , {
    headers: { "Content-Type": "application/json",
      "Authorization": `Bearer ${token}` },
  });
};

export const getUserOffersListFormData = (token) => { //Jobs
  return axios.get(`${constants.API_BASE_URL}offer/user`
  , {
    headers: { "Content-Type": "application/json",
      "Authorization": `Bearer ${token}` },
  });
};
export const getJobsListFormData = () => { //Jobs
  return axios.get(`${constants.API_BASE_URL}job`, {
    headers: { "Content-Type": "application/json"},
  });
};
export const getJobsListIdFormData = (Id) => { //Jobs by id
  return axios.get(`${constants.API_BASE_URL}job/${Id}`
  , {
    headers: { "Content-Type": "application/json" },
  });
};
export const getJobsDeleteFormData = (Id,token) => { //Jobs Delete by id
  return axios.post(`${constants.API_BASE_URL}job/delete/${Id}`
  , {
    headers: { "Content-Type": "application/json" ,'Authorization': `Bearer ${token}`},
  });
};
export const getBussinessDeleteFormData = (Id,token) => { //business Delete by id
  return axios.post(`${constants.API_BASE_URL}business/tempdelete/${Id}`
  , {
    headers: { "Content-Type": "application/json" ,'Authorization': `Bearer ${token}`},
  });
};
export const UpdatePostFormData = (data,Id,token) => { //business Delete by id
  return axios.put(`${constants.API_BASE_URL}blog/update-blog/blog/${Id}`,data
  , {
    headers: { "Content-Type": "application/json" ,'Authorization': `Bearer ${token}`},
  });
};

export const createJobsForBusniess = async (jobData, token) => { // Job Create
  axios.defaults.headers.post['Content-Type'] = 'application/json';
  
  const config = {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }
  };

  try {
    const response = await axios.post(`${constants.API_BASE_URL}job`, jobData, config);
    return response.data;
  } catch (error) {
    console.error('Error creating job:', error);
    throw error; // Optionally rethrow the error to handle it in the calling function
  }
};
export const getJobsUpdateFormData = (Id, jobData,token) => { // Job Update
  axios.defaults.headers.put['Content-Type'] = 'application/json';

  return axios.put(`${constants.API_BASE_URL}job/${Id}`, jobData, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
  });
};
export const getJobstypeDashboardData = (token) => { // Job Update
  axios.defaults.headers.put['Content-Type'] = 'application/json';

  return axios.get(`${constants.API_BASE_URL}job/jobtype`, {
    headers: { "Content-Type": "application/json" ,'Authorization': `Bearer ${token}`,},
    
  });
};
/// Offer Api
export const getOffersListFormData = (token) => { //Offer List
  return axios.get(`${constants.API_BASE_URL}offer`
  , {
    headers: { "Content-Type": "application/json" ,'Authorization': `Bearer ${token}`,},
    
  });
};
export const getOfferListIdFormData = (Id) => { //Offer by id
  return axios.get(`${constants.API_BASE_URL}offer/${Id}`
  , {
    headers: { "Content-Type": "application/json" },
  });
};
export const getAlumnisAllata = () => { //alumni by id
  return axios.get(`${constants.API_BASE_URL}alumni`
  , {
    headers: { "Content-Type": "application/json" },
  });
};
export const PostAlumnisAllata = async(postElement,data) => { //alumni by id
  console.log(data)
  try {
    const response = await axios.post(`${constants.API_BASE_URL}alumni/${postElement}`, data);
    return response;
} catch (error) {
    console.error("Error creating business", error);
    throw error;
}
 
};
export const getOfferDeleteFormData = (Id,token) => { //Offer Delete by id
  return axios.delete(`${constants.API_BASE_URL}offer/${Id}`
  , {
    headers: { "Content-Type": "application/json",'Authorization': `Bearer ${token}`},
  });
};
export const DeletePostListData = (Id,token) => { //blog Delete by id
  return axios.delete(`${constants.API_BASE_URL}blog/delete-blog/${Id}`
  , {
    headers: { "Content-Type": "application/json",'Authorization': `Bearer ${token}`},
  });
};
export const createOffersForBusniess = async (offerData, token) => { // Job Create
 const config = {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }
  };

  try {
    const response = await axios.post(`${constants.API_BASE_URL}offer`, offerData, config);
    return response.data;
  } catch (error) {
    console.error('Error creating offer:', error);
    throw error; // Optionally rethrow the error to handle it in the calling function
  }
};
export const getOffersUpdateFormData = (Id, jobData,token) => { //Job Update
  axios.defaults.headers.put['Content-Type'] = 'application/json';
  return axios.put(`${constants.API_BASE_URL}offer/${Id}`, jobData);
};
export const handlePasswordUpdate = (Data,token) => { //Job Update
  axios.defaults.headers.put['Content-Type'] = 'application/json';

  return axios.post(`${constants.API_BASE_URL}alumni/change-password`, Data, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
  });
};
export const getAboutMayoGallery = () => { //Offer by id
  return axios.get(`${constants.API_BASE_URL}gallery`
  , { 
    headers: { "Content-Type": "application/json" },
  });
};
export const getUserData = (Id,token) => { //Offer Delete by id
  return axios.get(`${constants.API_BASE_URL}alumni/alumniForm/${Id}`
  , {
    headers: { "Content-Type": "application/json",'Authorization': `Bearer ${token}`},
  });
};
export const saveEventAttendence = async (formData, token) => {
  //axios.defaults.headers.post["Content-Type"] = "application/json";

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const response = await axios.post(
      `${constants.API_BASE_URL}event/attendence`,
      formData,
      config
    );
    return response.data;
  } catch (error) {
    console.error("Error saving attendence:", error);
    throw error; // Optionally rethrow the error to handle it in the calling function
  }
};

export const getSearchApi = (keyword) => { //Search API
  return axios.get(`${constants.API_BASE_URL}search`, {params: { keyword }}
  , { 
    headers: { "Content-Type": "application/json" },
  });
};

export const getForgetPasswordAPI = (formData)=>{ // forget password api
  return axios.post(`${constants.API_BASE_URL}alumni/forgot-password`, formData,{
    headers: { "Content-Type": "application/json" },
  })
};
export const getEventsUserDetailFormData = (token) => { //Events
  return axios.get(`${constants.API_BASE_URL}payment/mybookings`, {
    headers: { "Content-Type": "application/json",'Authorization': `Bearer ${token}`},
  });
};
// export const getResetPasswordAPI = (formData, resetToken) => {
//   return axios.post(`${constants.API_BASE_URL}alumni/reset-password`, formData, {
//     headers: {
//       'Content-Type': 'application/json',
//       'Authorization': `Bearer ${resetToken}`,
//     },
//   });
// };
export const getResetPasswordAPI = (formData, resetToken) => {
  return axios.post(`${constants.API_BASE_URL}alumni/reset-password/${resetToken}`, formData, 
  );
};
